import { render, staticRenderFns } from "./InventoryLimitTable.vue?vue&type=template&id=70850aec"
import script from "./InventoryLimitTable.vue?vue&type=script&lang=js"
export * from "./InventoryLimitTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports